import React, { Fragment, useEffect, useState } from "react";
import { Form, Button, InputNumber, Select, Input } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { fetchQuestions, fetchQuestion } from "../../actions/question";
import { useDispatch, useSelector } from "react-redux";
import "./ScoreRule.scss";
import { ReactSVG } from "react-svg";
// import JoditEditor from "jodit-react";

const ScoreRuleForm = ({
	handleSubmitForm,
	form,
	handleCancel,
	questionId,
}) => {
	const dispatch = useDispatch();
	const [newQuestion, setNewQuestion] = useState("");
	const { questions } = useSelector((state) => state.fetchQuestions);
	const { question } = useSelector((state) => state.fetchQuestion);
	const handleQuestionChange = (id) => {
		dispatch(fetchQuestion(id));
	};

	useEffect(() => {
		if (question) {
			setNewQuestion(question);
		}
	}, [question]);

	useEffect(() => {
		if (questionId) dispatch(fetchQuestion(questionId));
	}, [questionId]);

	useEffect(() => {
		if (!questions) dispatch(fetchQuestions({}));
	}, [questions]);

	return (
		<div className="score-rule-form-container">
			<Form form={form} onFinish={handleSubmitForm} requiredMark={false}>
				<div className="form-content-group">
					<Form.Item
						label="Type"
						name="type"
						rules={[{ required: true, message: "Required" }]}
					>
						<Select>
							<Select.Option value="length">Length</Select.Option>
							<Select.Option value="selected">Selected</Select.Option>
						</Select>
					</Form.Item>
					<Form.Item label="Score" name="score">
						<InputNumber />
					</Form.Item>
					<Form.Item label="Min Length" name="min_length">
						<InputNumber />
					</Form.Item>
					<Form.Item label="Max Length" name="max_length">
						<InputNumber />
					</Form.Item>
					<Form.Item
						label="Question"
						name="question_id"
						rules={[{ required: true, message: "Required" }]}
					>
						{questions && (
							<Select
								showSearch
								maxTagCount={"responsive"}
								placeholder="Question"
								optionFilterProp="children"
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >=
									0
								}
								onChange={handleQuestionChange}
							>
								{questions.data.map((item, index) => (
									<Select.Option key={index} value={item.id}>
										{item.name}
									</Select.Option>
								))}
							</Select>
						)}
					</Form.Item>
					{newQuestion && newQuestion.answers.length !== 0 && (
						<Form.Item label="Answer" name="answer_ids">
							<Select
								showSearch
								maxTagCount={"responsive"}
								placeholder="Answer"
								optionFilterProp="children"
								filterOption={(input, option) =>
									option.children.toLowerCase().indexOf(input.toLowerCase()) >=
									0
								}
							>
								{newQuestion.answers.map((answer, index) => (
									<Select.Option key={index} value={answer.id}>
										{answer.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					)}
					<div className="products-list-form">
						<Form.List name="product_ids">
							{(fields, { add, remove }, { errors }) => (
								<Fragment>
									{fields.map((field, index) => (
										<Form.Item
											key={field.key}
											label={index === 0 ? "Products" : ""}
										>
											<Form.Item {...field}>
												<Input
													placeholder="Product"
													style={{ width: "100%" }}
												/>
											</Form.Item>
											{fields.length > 1 ? (
												<MinusCircleOutlined
													className="dynamic-delete-button"
													onClick={() => remove(field.name)}
												/>
											) : null}
										</Form.Item>
									))}
									<Form.Item>
										<Button
											type="dashed"
											onClick={() => add()}
											style={{ width: "100%" }}
											icon={<PlusOutlined />}
										>
											Add Product
										</Button>
										<Form.ErrorList errors={errors} />
									</Form.Item>
								</Fragment>
							)}
						</Form.List>
					</div>
					<Form.Item name="product_description" label="Product's Description">
						<Input.TextArea rows={3} />
					</Form.Item>
					<Form.Item name="product_status" label="Status">
						<Input />
					</Form.Item>
					<Form.Item name="product_recommendation" label="Recommendation">
						<Input />
					</Form.Item>
				</div>
				<div className="form-actions">
					<Button type="link" onClick={handleCancel}>
						{" "}
						Cancel{" "}
					</Button>
					<Button type="primary" htmlType="submit" className="btn-primary">
						Update
						<ReactSVG src="/icons/check-button.svg" />
					</Button>
				</div>
			</Form>
		</div>
	);
};

export default ScoreRuleForm;
